export default "__VITE_ASSET__BkeHvT6s__"